import React from 'react';
import { connect } from 'react-redux';
import * as classes from './CustomGapiBox.module.scss';
import * as actions from "store/actions/index";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomWithSpinner from 'Flow2/components/CustomCollections/CustomBox/CustomWithSpinner/CustomWithSpinner';
import * as CustomDataBox from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";


const SignInWithGoogle = (props) => {
    return (<div className={classes.CustomButtonGroup}>
        <h3>Login with Google</h3>
        <button style={{ border: 'none' }} id="loginButton">Login with Google</button>
        <button className={classes.CustomPopUpButton} onClick={props.onCloseButton}>Schließen</button>
    </div>)
}

const CustomAnalyticsPopUp = (props) => {
    let visits = (props.report && props.report.visits) ? props.report.visits : null;
    let users = (props.report && props.report.users) ? props.report.users : null;
    let hits = (props.report && props.report.hits) ? props.report.hits : null;
    return (
        <div className={classes.CustomOverlay}>
            <div className={classes.CustomPopUp}>
                <h1>Google Analytics</h1>
                {props.isSignedIn ? (
                    <div className={classes.CustomSignInGroup}>
                        <p>{visits ? `Visits: ${visits}` : null}  {users ? `Users: ${users}` : null} {hits ? `Hits: ${hits}` : null}</p>
                        <div className={classes.CustomTextAreaContainer} >
                            <textarea className={classes.CustomPopUpTextArea} cols="90" id="query-output" />
                            {props.showSpinner ? <div className={classes.CustomSpinnerContainer}><CustomDataBox.CustomSpinner isLoading={props.showSpinner} /></div> : null}
                        </div>
                        <button className={classes.CustomButton} onClick={props.onCloseButton}>Schließen</button>
                    </div>
                )
                    : <SignInWithGoogle {...props} />
                }
            </div>
        </div >
    )
}
const CustomAnalyticsPopUpWithSpinner = CustomWithSpinner(CustomAnalyticsPopUp);


class CustomGapiBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isSignedIn: false,
            report: null,
            isLoading: false,
            showSpinner: true,
        }
    }

    componentDidMount() {
        const successCallback = this.onSuccess.bind(this);
        window.gapi.load('auth2', () => {
            this.auth2 = window.gapi.auth2.init({
                client_id: this.props.clienId,
            })
            this.auth2.then(() => {
                this.setState({ isSignedIn: this.auth2.isSignedIn.get() }, () => {
                    if (!this.state.isSignedIn) this.setState({ isLoading: false });
                });
            });
        });

        window.gapi.load('signin2', () => {
            let opts = {
                width: 250,
                height: 50,
                client_id: this.props.clienId,
                onsuccess: successCallback
            }
            window.gapi.signin2.render('loginButton', opts)
        })
    }

    handleAccounts = (response) => {
        if (response.result.items && response.result.items.length) {
            let firstAccountId = response.result.items[0].id;
            this.queryProperties(firstAccountId);
        } else {
            console.log('No accounts found for this user.');
        }
    }

    queryAccounts = () => {
        window.gapi.client.load('analytics', 'v3').then(() => {
            //window.gapi.client.analytics.management.accounts.list().then(this.handleAccounts);
            window.gapi.client.analytics.management.accounts.list()
                .then(response => this.handleAccounts(response));
        });
    }
    queryProperties = (accountId) => {
        window.gapi.client.analytics.management.webproperties.list(
            { 'accountId': accountId })
            .then(this.handleProperties)
            .then(null, function (err) {
                console.log(err);
            });
    }

    handleProperties = (response) => {
        if (response.result.items && response.result.items.length) {
            let firstAccountId = response.result.items[0].accountId;
            let firstPropertyId = response.result.items[0].id;
            this.queryProfiles(firstAccountId, firstPropertyId);
        } else {
            console.log('No properties found for this user.');
        }
    }


    queryProfiles = (accountId, propertyId) => {
        window.gapi.client.analytics.management.profiles.list({
            'accountId': accountId,
            'webPropertyId': propertyId
        })
            .then(this.handleProfiles)
            .then(null, function (err) {
                console.log("LAMTEST queryProfiles Error", err);
            });
    }


    handleProfiles = (response) => {
        if (response.result.items && response.result.items.length) {
            let firstProfileId = response.result.items[0].id;
            this.queryCoreReportingApi(firstProfileId);
        } else {
            console.log("LAMTEST handleProfiles  No views (profiles) found for this user.");
        }
    }

    getAnalyticsInfo = (report, info) => {
        let res = null;

        const getInfo = (termAfter, termBefore) => {
            res = DataUtil.subStringAfter(report, termAfter);
            res = DataUtil.subStringBefore(res, termBefore);
            return res;
        }
        switch (info) {
            case "visits":
                return getInfo('ga:visits":"', '","ga:users');
            case "users":
                return getInfo('ga:users":"', '","ga:newUsers"');
            case "hits":
                return getInfo('ga:hits":"', '","ga:bounces');
        }
    }

    queryCoreReportingApi = (profileId) => {
        let startDate = (this.props.startDate && this.props.startDate !== "") ? this.props.startDate : '7daysAgo';
        let endDate = (this.props.endDate && this.props.endDate !== "") ? this.props.endDate : "today";
        window.gapi.client.analytics.data.ga.get({
            'ids': 'ga:' + profileId,
            'start-date': startDate,
            'end-date': endDate,
            'metrics': 'ga:sessions, ga:visits, ga:users, ga:newUsers, ga:hits, ga:bounces'
        })
            .then((response) => {
                let formattedJson = JSON.stringify(response.result, null, 2);
                let report = JSON.stringify(response.result.totalsForAllResults);
                let visits = this.getAnalyticsInfo(report, "visits");
                let users = this.getAnalyticsInfo(report, "users");
                let hits = this.getAnalyticsInfo(report, "hits");
                document.getElementById('query-output').value = formattedJson;
                this.setState({ report: { visits: visits, users: users, hits: hits }, showSpinner: false })
            })
            .then(null, function (err) {
                console.log("LAMTEST queryCorereportApi Error", err);
            });
    }

    onSuccess = () => {
        this.setState({ isSignedIn: true, err: null, isLoading: false });
        this.props.setCustomGoogleSignIn(true);
        this.queryAccounts();
    }

    onLoginFailed = (err) => {
        this.setState({ isSignedIn: false, error: err, });
        console.log("LAMTEST ERROR", err);
    }

    onCloseButton = () => {
        this.props.togglePopUpHidden();
    }


    render() {
        return (
            <CustomAnalyticsPopUpWithSpinner
                isLoading={this.state.isLoading}
                onCloseButton={this.onCloseButton}
                isSignedIn={this.state.isSignedIn}
                report={this.state.report}
                showSpinner={this.state.showSpinner}
            />
        )
    }
}

const mapStateToProps = (state) => ({
    customPopUpHidden: state.customData.customPopUpHidden
});

const mapDispatchToProps = (dispatch) => ({
    togglePopUpHidden: () => dispatch(actions.toggleCustomPopUpHidden()),
    setCustomGoogleSignIn: (data) => dispatch(actions.setCustomGoogleSignIn(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomGapiBox);